import axios from 'axios';

const API_URL = process.env.REACT_APP_LIVE_API_URL;
const TOKEN = localStorage.getItem('serviceToken');

const fetchUpdatedInventory = async (page, spaceBookingId) => {
  let pageNum = Number(page);
  const config = {
    method: 'post',
    url: API_URL + `report/updated_inventory?page=${pageNum}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + TOKEN
    },
    data: {
      spaceBookingId: spaceBookingId
    }
  };
  const response = await axios(config);
  if (response) {
    return response.data;
  }
};

const fetchLocationWiseInventory = async (page, spaceBookingId) => {
  let pageNum = Number(page);
  const config = {
    method: 'post',
    url: API_URL + `report/location_wise_inventory?page=${pageNum}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + TOKEN
    },
    data: {
      spaceBookingId: spaceBookingId
    }
  };
  const response = await axios(config);
  if (response) {
    return response.data;
  }
};

const fetchDamageInventory = async (page, spaceBookingId) => {
  let pageNum = Number(page);
  const config = {
    method: 'post',
    url: API_URL + `report/damage_inventory?page=${pageNum}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + TOKEN
    },
    data: {
      spaceBookingId: spaceBookingId
    }
  };
  const response = await axios(config);
  if (response) {
    return response.data;
  }
};

// report setup
const createReportSetup = async (reportSetupData) => {
  const config = {
    method: 'post',
    url: API_URL + 'report_setup/create_report_setup',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + TOKEN
    },
    data: reportSetupData
  };
  const response = await axios(config);
  if (response) {
    return response.data;
  }
};
const fetchReportSetupList = async (page, organizationId) => {
  let pageNum = Number(page);
  const config = {
    method: 'post',
    url: API_URL + `report_setup/list?page=${pageNum}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + TOKEN
    },
    data: {
      organizationId: organizationId
    }
  };

  const response = await axios(config);
  if (response) {
    return response.data;
  }
};

const reportSetupStatus = async (data) => {
  const config = {
    method: 'post',
    url: API_URL + `report_setup/status`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + TOKEN
    },
    data: data
  };
  const response = await axios(config);
  if (response) {
    return response.data;
  }
};

const fetchReportSetupDetail = async (data) => {
  const config = {
    method: 'post',
    url: API_URL + `report_setup/get_single`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + TOKEN
    },
    data: data
  };
  const response = await axios(config);
  if (response) {
    return response.data;
  }
};

const updateReportSetup = async (data) => {
  const config = {
    method: 'post',
    url: API_URL + 'report_setup/edit',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + TOKEN
    },
    data: data
  };
  const response = await axios(config);
  if (response) {
    return response.data;
  }
};

const addReportSetting = async (reportSettingData) => {
  const config = {
    method: 'post',
    url: API_URL + 'report_setup/add_report_setting',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + TOKEN
    },
    data: reportSettingData
  };
  const response = await axios(config);
  if (response) {
    return response.data;
  }
};

const fetchReportSettingDetail = async (data) => {
  const config = {
    method: 'post',
    url: API_URL + `report_setup/report_setting_detail`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + TOKEN
    },
    data: data
  };
  const response = await axios(config);
  if (response) {
    return response.data;
  }
};

const testMailReport = async (data) => {
  const config = {
    method: 'post',
    url: API_URL + 'report_setup/test_mail',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + TOKEN
    },
    data: data
  };
  const response = await axios(config);
  if (response) {
    return response.data;
  }
};

const fetchLedgerReport = async (page, data) => {
  let pageNum = Number(page);
  const config = {
    method: 'post',
    url: API_URL + `report/ledger_report?page=${pageNum}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + TOKEN
    },
    data: data
  };
  const response = await axios(config);
  if (response) {
    return response.data;
  }
};

const reportService = {
  fetchUpdatedInventory,
  fetchLocationWiseInventory,
  fetchDamageInventory,
  createReportSetup,
  fetchReportSetupList,
  reportSetupStatus,
  fetchReportSetupDetail,
  updateReportSetup,
  addReportSetting,
  fetchReportSettingDetail,
  testMailReport,
  fetchLedgerReport
};

export default reportService;
